module.exports = __webpack_public_path__ + "img/pyramid_pink.3f8fc9e2.png";